import { App, Button, Flex } from 'antd';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';
import { getLocale } from 'translations/locale';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useTableParams } from 'business/providers/table-params';
import { formatFilterParams } from 'business/quality-control/pages/defect-report-history/hooks/data/utils';
import { useDefectReportHistoryFilters } from 'business/quality-control/pages/defect-report-history/providers/filters';
import { useGetDefectIndicatorData } from 'business/quality-control/pages/record-segment-defect/hooks/data/get-defect-indicator';
import config from 'config';
import { useDefectReportV1ControllerExport } from 'generated/apiComponents';
import { SORT_ORDER } from 'technical/graphql/sort-order';
import { downloadFile } from 'technical/print';

export const DefectReportHistoryHeader = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'No construction site');

  const filters = useDefectReportHistoryFilters();
  const { hasIndicators } = useGetDefectIndicatorData(
    currentConstructionSiteId,
  );
  const { tableParams } = useTableParams();

  const sortOrder = tableParams.sortOrder
    ? SORT_ORDER[tableParams.sortOrder]
    : null;

  const { mutate: generateExport, isPending } =
    useDefectReportV1ControllerExport({
      onSuccess: (data) => {
        downloadFile(`${config.gcp.publicUri}/${data.url}`, data.fileName);
      },
      onError: () => {
        message.open({
          type: 'error',
          content: t('errors.export_download_error'),
        });
      },
    });

  const handleExport = () => {
    generateExport({
      pathParams: { constructionSiteId: currentConstructionSiteId },
      body: {
        ...formatFilterParams(filters, { hasIndicators }),
        paginationSortField: tableParams.sortField?.toString(),
        paginationSortDirection: sortOrder,
        locale: getLocale(),
      },
    });
  };

  return (
    <Flex gap={4}>
      <Button type="primary" loading={isPending} onClick={handleExport}>
        {t('common.export')}
      </Button>
    </Flex>
  );
};
